import { GridColDef } from '@mui/x-data-grid';

import { FollowUpWidget } from '../../../../../features/composableAnalytics/DerivedCharts/helper';
import { IPostgresFollowUpDTO } from '../types/postgresFollowUpDTO';

export const getColumnsForFollowUps = (
  widgetName: FollowUpWidget,
  widgetData: IPostgresFollowUpDTO
): GridColDef[] => {
  const uniqueStatus = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.statusWithCount ?? '')))
  );
  switch (widgetName) {
    case FollowUpWidget.TASK_STATUS:
      return [
        { field: 'recruiterName', headerName: 'Recruiter Name', width: 180 },
        { field: 'count', headerName: `Total Count(${widgetData?.totalCount ?? 0})`, width: 150 },
        ...uniqueStatus.map((status) => ({
          field: status,
          headerName: status,
          width: 110,
        })),
      ];
    default:
      throw new Error('Invalid table widget name');
  }
};

export function getTableDataForFollowUps(
  widgetName: FollowUpWidget,
  widgetData: IPostgresFollowUpDTO
) {
  const uniqueStatus = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.statusWithCount ?? '')))
  );
  switch (widgetName) {
    case FollowUpWidget.TASK_STATUS:
      widgetData?.resultSet?.forEach((record, index) => {
        record.id = index;
        uniqueStatus.forEach((status) => {
          record[status] = record?.statusWithCount?.[status] || 0;
        });
      });
      return widgetData?.resultSet;
    default:
      return [];
  }
}

export const defaultFollowUpWidgetData: IPostgresFollowUpDTO = {
  count: 0,
  totalCount: 0,
  resultSet: [],
  result: {
    series: [],
    categories: [],
  },
};
